module.exports = __webpack_public_path__ + "assets/img/wallpaper-blurred.2077a424.jpg";